import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { enableVisibility, disableVisibility } from '../actions/proctor';
import { trackWindowBlur, trackWindowFocus } from '../actions/eventTracking';
import VisibilityProctor from '../components/Proctor/VisibilityProctor';

const mapStateToProps = state => {
  return {
    test: state.test,
    testSolutionSet: state.testSolutionSet,
    visibilityEnabled: state.proctor.visibilityEnabled,
    socketActive: state.socket.socketActive,
    showBrowserTolerance: state.proctor.showBrowserTolerance,
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      enableVisibility,
      disableVisibility,
      trackWindowBlur,
      trackWindowFocus,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(VisibilityProctor);
